/* eslint-disable */
import queryString from 'query-string';

export function updateQueryParam( newQueryParams ){
    let queryParams = queryString.parse( location.search );

    queryParams = {
        ...queryParams,
        ...newQueryParams
    };

    if( history.pushState ){
        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${queryString.stringify( queryParams )}`;
        window.history.pushState( { path:newurl },'',newurl );
    }
}

export function getQueryParams(){
    return queryString.parse( location.search );
}
